export class GUID {
    private guid: string;

    constructor(guid?: string) {
        this.guid = guid || GUID.newGuid();
    }

    public toString(): string {
        return this.guid;
    }

    public static newGuid(): string {
        let d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/main/helpers/guid.helper.ts